import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { useRoot } from 'context/RootContext';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS, HTTP_VERBS } from 'utils/constants';

const useStartShift = () => {
  const path = `${API_ENDPOINTS.SHIFTS}/start`;
  const { t } = useTranslation(LOCALIZATION_PAGES.SHIFT);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, startShift] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.POST,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('start_shift_fail'),
        },

        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('start_shift_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, startShift];
};

export default useStartShift;
